import React, {Component} from 'react';
import Avi from '../assets/profile.jpg';
import editbutton from '../assets/edit-image.svg';
import { Link } from 'react-router-dom';

class EditAdmin extends Component{
    render(){
        return(
            <div className="edit-caregiver">
                <div className="row">
                    <div className="col-sm-8">
                    <form>
                        <div className="edit-div">
                            <h4>Change admin details</h4>
                            <div className="row">
                                <div className="col-sm-2">
                                    <div className="img-div">
                                        <img src={Avi} alt=""/>
                                        <img src={editbutton} alt="" className="edit-image"/>
                                    </div>
                                </div>
                                <div className="col-sm-10">
                                    <div className="row">
                                        <div className="col-sm-6">
                                            <label>
                                                Email
                                                <input type="email"/>
                                            </label>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="edit-div buttons">
                            <div className="button-div">
                                <Link to='/profile'><button className="cancel-btn">Cancel</button></Link>
                                <button type="submit">Save Changes</button>
                            </div>
                        </div>
                    </form>
                    </div>
                </div>
            </div>
        )
    }
}

export default EditAdmin;


// WEBPACK FOOTER //
// ./src/components/EditAdmin.js